module.exports = __webpack_public_path__ + "img/image (12).ba09baa0.png";